import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  public formFields: FormGroup;
  public submitted = false;
  showSpinner : boolean  = false;

  constructor(private fb: FormBuilder,
    private auth:ApiCall,
    private router:Router,
    private toastr:ToastrService,
    private translate: TranslateService
    ) { }

  ngOnInit(): void {
    this.formFields = this.fb.group({
      email: ["",[Validators.required,Validators.email,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]]
    })
  }
  get formControl() {
    return this.formFields.controls;
  }

  onForget() {
    this.showSpinner=true;
    this.submitted = true;
    if (!this.formFields.valid) {
      this.showSpinner=false;
      return;
    }
    this.auth.forgetPassword(this.formFields.value).subscribe(
      (res: any) => {
        if(res.status == 'SUCCESS'){
          this.showSpinner= false;      
          this.translate.get(['ALL_USER_FORGOT_PASSWORD'])
          .subscribe(translations => {
            res.message = translations['ALL_USER_FORGOT_PASSWORD'];
         }); 
          this.toastr.success(res.message,'',{
               timeOut:3000, messageClass: 'test'
          });
          this.router.navigate(["/landing-page"]);
        }else{
          this.showSpinner= false;  
          let message;
          this.translate.get(['USER_EMAIL_INVALID'])
          .subscribe(translations => {
            message = translations['USER_EMAIL_INVALID'];
         }); 
          this.toastr.error(message,'',{
            timeOut:3000
          });
        }
      },
      (err: any) => {
        this.showSpinner= false;  
        console.log("Something went wrong");
      }
    );
  }

}
